import React from 'react';
import ReactDOM from 'react-dom';
import './stylesheets/App.scss';
import App from './components/App';
import { HashRouter } from 'react-router-dom';

ReactDOM.render(
    <HashRouter>
      <App />
    </HashRouter>,
    document.getElementById('root')
  );